export default __webpack_public_path__ + "static/media/acrobatAndYoungHarlequin.b7392689.jpg";